import { createModel } from '@rematch/core';
import { RootModel } from './RootState';
import { ActiveHelp } from '../models/ActiveHelp';
import { dispatchEvent } from '../services/EventService';

export type ActiveHelpState = {
    isInitialized: boolean;
    isVisible: boolean;
    scenarioName: string;
    currentActiveHelp: ActiveHelp | null;
};

const initialState: ActiveHelpState = {
    isInitialized: false,
    isVisible: false,
    currentActiveHelp: null,
    scenarioName: ''
};

export const activeHelpState = createModel<RootModel>()({
    state: initialState,
    reducers: {
        show(state, newState: Partial<ActiveHelpState>) {
            return {
                ...state,
                ...newState,
                isVisible: true,
                isInitialized: true
            };
        },
        hide(state) {
            return {
                ...state,
                isVisible: false
            };
        }
    },
    effects: dispatch => ({
        showIfAssistantIsMinified(
            data: {
                scenarioName: string;
                activeHelp: ActiveHelp;
            },
            state
        ) {
            if (
                state.activeHelpState.isVisible ||
                state.uiState.mode !== 'button'
            ) {
                return;
            }
            dispatch.activeHelpState.show({
                scenarioName: data.scenarioName,
                currentActiveHelp: data.activeHelp
            });
            dispatchEvent({
                type: 'bri.view_active_help',
                isInteraction: false,
                scenarioName: data.scenarioName ?? '',
                activeHelpDescription: data.activeHelp.description ?? '',
                activeHelpTitle: data.activeHelp.title ?? ''
            });
        },
        applyActiveHelpClick(_: void, state) {
            const { currentActiveHelp, isVisible } = state.activeHelpState;
            if (
                !currentActiveHelp ||
                !isVisible ||
                state.uiState.mode !== 'button'
            ) {
                return;
            }
            const { featureOptions } = currentActiveHelp;
            dispatch.activeHelpState.hide();
            if (!featureOptions) {
                dispatch.uiState.setMode('menu');
            } else {
                void dispatch.featureState.startFeature(featureOptions);
                dispatch.uiState.setMode('full');
            }
        }
    })
});
